import ScrollReveal from './ScrollReveal';

export default function FinalCTA() {
  return (
    <section className="py-20 md:py-28 bg-[#FFFFFF] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gradient-to-tr from-[#E53935]/[0.03] via-transparent to-[#C8A24A]/[0.03] rounded-full blur-3xl pointer-events-none"></div>

      <div className="mx-auto max-w-[1280px] px-6 md:px-10 relative">
        <ScrollReveal>
          <div className="max-w-[700px] mx-auto text-center">
            {/* Gold line */}
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-[#C8A24A]/50 to-transparent mx-auto mb-8"></div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111] leading-[1.2] mb-6">
              Empieza hoy a construir campañas que realmente venden.
            </h2>

            <p className="text-[#666666] text-base md:text-lg mb-8 max-w-[500px] mx-auto">
              No necesitas más herramientas ni más cursos. Todo lo que necesitas para dominar Meta Ads con IA está aquí.
            </p>

            {/* Price */}
            <div className="mb-10">
              <div className="flex items-baseline justify-center gap-3 mb-6">
                <span className="text-4xl md:text-5xl font-bold text-[#111111] font-heading">$9.9 USD</span>
              </div>

              <a
                href="https://pay.hotmart.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-full bg-[#E53935] text-white font-bold text-base hover:bg-[#B71C1C] transition-all duration-300 whitespace-nowrap shadow-[0_6px_30px_rgba(229,57,53,0.35)] hover:shadow-[0_8px_36px_rgba(229,57,53,0.5)] hover:-translate-y-1 cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line text-xl"></i>
                Comprar en Hotmart
              </a>
            </div>

            {/* Trust text */}
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-sm text-[#888888]">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-flashlight-line text-[#E53935]"></i>
                Acceso inmediato
              </span>
              <span className="w-1 h-1 rounded-full bg-gray-300"></span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-money-dollar-circle-line text-[#E53935]"></i>
                Pago único
              </span>
              <span className="w-1 h-1 rounded-full bg-gray-300"></span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-refresh-line text-[#E53935]"></i>
                Actualizaciones incluidas
              </span>
            </div>

            {/* Bottom gold accent */}
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-[#C8A24A]/50 to-transparent mx-auto mt-10"></div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}